/**
 * AI 生图
 * @returns
 */
import {
  Box,
  Flex,
} from "@chakra-ui/react";
import { useEffect } from "react";
import CenterMainView from "@/components/design/center_main_view";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import Client4 from "@/services/api/client4";
import { contentReceived, contentRemoveAll } from "@/reducer/contentSlice";
import { selectUser } from "@/reducer/userslice";
const Design = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser)

  useEffect(()=>{
    const fetchContent = async ()=>{
      try{
        if (user.id){
          const result = await Client4.getContents(0,9999,"",user.id)
          dispatch(contentReceived(result))
        }else{
          dispatch(contentRemoveAll())
        }
      }catch(error){
        dispatch(contentRemoveAll())
      }
    };
    fetchContent();
  },[])

  return (
    <Box bgColor={"#0C0B10"} h="100vh" overflow={"hidden"}>
      <Flex h="100%" justifyContent="space-between" p="1.25rem">
        <Box h="100%" flex={1}>
          {/* 中间内容 */}
          <Box h="100%">
            <CenterMainView />
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default Design;
